import { styled } from '@mui/material/styles'
import { Autocomplete } from '@mui/material'
import { AutocompleteProps } from '@mui/material/Autocomplete'

const BaseStyledAutocomplete = styled('div')(({ theme }) => ({
  '& .MuiAutocomplete-popupIndicator': {
    color: theme.palette.grey[500],
    transform: `translateY(${theme.spacing(1.5)})`,
  },
}))

export function StyledAutocomplete<
  T,
  Multiple extends boolean = false,
  DisableClearable extends boolean = false,
  FreeSolo extends boolean = false
>(props: AutocompleteProps<T, Multiple, DisableClearable, FreeSolo>) {
  return (
    <BaseStyledAutocomplete>
      <Autocomplete {...props} />
    </BaseStyledAutocomplete>
  )
}
